import { render, staticRenderFns } from "./ModalLicenceApplication.vue?vue&type=template&id=e67870fe&scoped=true&"
import script from "./ModalLicenceApplication.vue?vue&type=script&lang=ts&"
export * from "./ModalLicenceApplication.vue?vue&type=script&lang=ts&"
import style0 from "./ModalLicenceApplication.vue?vue&type=style&index=0&id=e67870fe&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e67870fe",
  null
  
)

export default component.exports